// extracted by mini-css-extract-plugin
export default {"message":"Cr8_EsdFBmbwpOqJ0acJ","messageText":"BQmRcsgDvlMlDa2P03UM"};